const CAP = {
  "title": "Capítulo 6 — Sin Claves (Keyless)",
  "sections": [
    {
      "heading": "¿Qué significa Keyless?",
      "text": [
        "Keyless significa **“sin llave privada”**. En este modelo, el usuario NO administra directamente una **llave privada** ni una **frase semilla (seed phrase)**.",
        "En lugar de tener que anotar, guardar o memorizar una semilla, el acceso a la billetera se realiza mediante métodos como email, contraseña, autenticación biométrica o procesos criptográficos avanzados.",
        "Para fines didácticos, podemos dividir el ecosistema Keyless en dos grandes categorías (esta clasificación no es un estándar de la industria, pero ayuda mucho a entenderlo):"
      ],
      "list": [
        "**Custodial**: un tercero controla y administra tus claves por ti.",
        "**No-Custodial Keyless**: no hay clave privada visible, pero el usuario mantiene control mediante autenticación Web2/MPC."
      ]
    },
    {
      "heading": "1. Keyless Custodial",
      "text": [
        "En este modelo, un servicio centralizado (como un exchange o una billetera con custodia) administra completamente las claves privadas.",
        "El usuario solo necesita **crear una cuenta** y **establecer una contraseña**, igual que en una plataforma tradicional como Gmail o Facebook.",
        "Nunca ves una clave privada ni una frase semilla. Depositaste tu confianza en la empresa que mantiene tus activos."
      ],
      "list": [
        "**Ejemplos**: exchanges centralizados (CEX), billeteras custodiales como Binance Wallet, Coinbase, OKX.",
        "**Ventaja**: experiencia extremadamente sencilla, ideal para principiantes.",
        "**Riesgo**: si el exchange es hackeado, bloqueado legalmente o quiebra, tus fondos pueden perderse —y tú no puedes hacer nada para recuperarlos."
      ],
      "note": "**Si no controlas la clave, no controlas los fondos.**"
    },
    {
      "heading": "2. Keyless No-Custodial",
      "text": [
        "En este modelo, el usuario mantiene un tipo de control, pero no existe una clave privada tradicional visible.",
        "La seguridad se basa en tecnologías como **MPC (Computación Multipartita)**, donde la clave se divide en partes. Ninguna persona, ni siquiera el sistema, posee la clave completa.",
        "También puede combinarse con **autenticación tipo Web2** (correo, FaceID, Google, Apple, biometría), donde varios factores juntos validan tu acceso.",
        "El objetivo es evitar un **punto único de fallo** como una llave privada escrita en un papel, una foto en el celular o 12 palabras fáciles de robar."
      ],
      "list": [
        "La seguridad depende de cómo se distribuya la clave (MPC) o de los proveedores de autenticación.",
        "Proyectos destacados: **ZenGo**, **Fireblocks**, **Safeheron**, **Web3Auth**.",
        "Ventaja: la **clave privada nunca existe en un solo lugar**, por lo tanto no hay una semilla que te puedan robar o perder."
      ],
      "note": "En este modelo, tú sigues teniendo control, pero **sin tener que escribir una seed ni preocuparte por dónde guardarla**."
    },
    {
      "heading": "Ventajas del enfoque Keyless (especialmente MPC)",
      "text": [
        "Este modelo está creciendo rápidamente porque combina seguridad técnica con facilidad de uso, especialmente en aplicaciones Web3, wallets móviles y soluciones empresariales."
      ],
      "list": [
        "La ingeniería MPC ya funciona en las principales blockchains (Ethereum, Bitcoin, Polygon, Solana).",
        "Un solo diseño puede ofrecer la misma experiencia, incluso si cambias de blockchain.",
        "Evita que exista una clave privada como archivo, papel o semilla escrita.",
        "Al combinarse con autenticación Web2 (email, FaceID, biometría), la experiencia es muy fluida para usuarios nuevos."
      ]
    },
    {
      "heading": "Desventajas y consideraciones",
      "text": [
        "Aunque suene ideal, el mundo Keyless también tiene límites y riesgos que debemos conocer:"
      ],
      "list": [
        "Algunas soluciones no son completamente **open source**, lo que dificulta confiar plenamente.",
        "Muchos usuarios solo usan Ethereum / EVM, donde billeteras multisig tradicionales (como **Gnosis Safe**) ya ofrecen buena seguridad sin necesidad de MPC.",
        "Depender de proveedores Cloud o autenticación Web2 introduce un vector de riesgo (hackeo de correo, suplantación de identidad, SIM swap).",
        "Algunas wallets Keyless son muy nuevas: aún no han sido probadas con ataques reales a gran escala."
      ]
    },
    {
      "heading": "Conclusión",
      "text": [
        "El enfoque Keyless es una evolución importante de la seguridad, especialmente para quienes no quieren preocuparse por frases semillas, backups o restauraciones.",
        "Sin embargo, no significa que sea automáticamente mejor: simplemente ofrece una **alternativa distinta**, con ventajas y riesgos propios.",
        "En general, cualquier herramienta que te haga sentir **seguro**, en control y con buena experiencia, es una herramienta válida.",
        "Con esto concluimos las consideraciones principales sobre la creación y diseño de billeteras. En los capítulos siguientes veremos riesgos reales al conectarlas con DApps, firmar transacciones y mover valor en la blockchain."
      ]
    }
  ]
}

export default CAP;
